<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import headTop from './components/headTop';
import "@/assets/css/theme/da2337/index.css"; // 换肤版本00a597 css
import "@/assets/css/theme/14A83B/index.css"; // 换肤版本00a597 css
import "@/assets/common.css"
import "../static/less/color.less"
import { toggleClass } from '@/utils/index'
import config from './assets/js/config';
import context from './utils/context';
export default {
  name: 'app',
  data () {
    return {

    }
  },
  components: {
    headTop,
  },
	mounted(){
		let apiRoot = window.location.host.split('.')[0];
		let adminUser = config.apiRoot[apiRoot];

      let app = document.getElementById("app");
      if(adminUser.RequestUnit=='IsFangCao'){
          app.className = "theme-fangcao";
      }else if (adminUser.RequestUnit=='IsAixiuxing'){
          app.className = "theme-reliable";
      }else if (adminUser.RequestUnit=='localhost:8099'){
          app.className = "theme-reliable";
      }else{
          app.className = "theme-reliable";
      }
	}
}

</script>

<style lang="less">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /*text-align: center;*/
  color: #2c3e50;
}

  * {
    margin: 0;
    padding: 0;
  }

  html {
    width: 100%;
    height: 100%;
  }
	.flex{
      display: -webkit-flex;
      display: flex;
    }
	.clear:after {
		content: "";
		display: block;
		clear: both;
		vertical-align: hidden;
	}



</style>



// WEBPACK FOOTER //
// App.vue?7d83505d